module.exports = __webpack_public_path__ + "static/visual_7_dont-e2ffd29cc43385ee33ceaadd134c7ff2.png";